
import { computed, defineComponent } from 'vue'
import { EThemeConcepts } from '@/services/theme'

import { Heading } from '@/components/Heading'
import { Text } from '@/components/Text'

export default defineComponent({
  name: 'CardInfo',
  components: { Heading, Text },
  props: {
    title: { type: String, required: true },
    color: { type: String, default: EThemeConcepts.overBackgroundElement },
  },
  setup(props) {
    const computedBackground = computed(() => ({ background: props.color }))
    return { computedBackground }
  },
})
